/** Mirrors backend BASKETBALL_FORMATIONS in application/routes/match/basketball/tactics.py */
export const BASKETBALL_FORMATIONS = {
  "5v5": {
    players: 5,
    categories: {
      defensive: ["Pack Line", "2-3 Zone", "Box-and-One", "Triangle-and-Two"],
      balanced: ["2-1-2 Motion", "Horns", "Flex", "Princeton"],
      attacking: ["4-Out 1-In", "Dribble Drive", "Spread Pick-and-Roll", "Motion Strong"],
      uptempo: ["5-Out Pace", "Push Transition", "Full-Court Press Break", "Seven Seconds or Less"],
    },
  },
  "3v3": {
    players: 3,
    categories: {
      defensive: ["Switch Everything", "Gap Help", "Deny Pick"],
      balanced: ["Spread", "Ball Screen Side", "Mirror"],
      attacking: ["Pick and Roll", "Misdirection", "Isolation Clear"],
      uptempo: ["Push Pace", "Fly Wheel", "Quick Strike"],
    },
  },
};

const FIVE_V5_DEFAULT = [
  { x: 50, y: 88, role: "point_guard" },
  { x: 20, y: 72, role: "shooting_guard" },
  { x: 80, y: 72, role: "wing" },
  { x: 35, y: 48, role: "power_forward" },
  { x: 65, y: 48, role: "center" },
];

const THREE_V3_DEFAULT = [
  { x: 50, y: 86, role: "point_guard" },
  { x: 28, y: 58, role: "wing" },
  { x: 72, y: 58, role: "center" },
];

/** Court spots per set name (percentage x/y, offensive half — basket at bottom). */
export const BASKETBALL_FORMATION_LAYOUTS = {
  "5v5": {
    "Pack Line": FIVE_V5_DEFAULT,
    "2-3 Zone": [
      { x: 50, y: 88, role: "point_guard" },
      { x: 25, y: 68, role: "shooting_guard" },
      { x: 75, y: 68, role: "wing" },
      { x: 40, y: 42, role: "power_forward" },
      { x: 60, y: 42, role: "center" },
    ],
    "Box-and-One": FIVE_V5_DEFAULT,
    "Triangle-and-Two": FIVE_V5_DEFAULT,
    "2-1-2 Motion": FIVE_V5_DEFAULT,
    Horns: [
      { x: 50, y: 88, role: "point_guard" },
      { x: 38, y: 72, role: "shooting_guard" },
      { x: 62, y: 72, role: "wing" },
      { x: 42, y: 55, role: "power_forward" },
      { x: 58, y: 55, role: "center" },
    ],
    Flex: FIVE_V5_DEFAULT,
    Princeton: FIVE_V5_DEFAULT,
    "4-Out 1-In": [
      { x: 50, y: 88, role: "point_guard" },
      { x: 15, y: 62, role: "shooting_guard" },
      { x: 85, y: 62, role: "wing" },
      { x: 35, y: 62, role: "power_forward" },
      { x: 50, y: 42, role: "center" },
    ],
    "Dribble Drive": FIVE_V5_DEFAULT,
    "Spread Pick-and-Roll": FIVE_V5_DEFAULT,
    "Motion Strong": FIVE_V5_DEFAULT,
    "5-Out Pace": [
      { x: 50, y: 88, role: "point_guard" },
      { x: 15, y: 58, role: "shooting_guard" },
      { x: 85, y: 58, role: "wing" },
      { x: 32, y: 38, role: "power_forward" },
      { x: 68, y: 38, role: "center" },
    ],
    "Push Transition": FIVE_V5_DEFAULT,
    "Full-Court Press Break": FIVE_V5_DEFAULT,
    "Seven Seconds or Less": FIVE_V5_DEFAULT,
  },
  "3v3": {
    "Switch Everything": THREE_V3_DEFAULT,
    "Gap Help": THREE_V3_DEFAULT,
    "Deny Pick": THREE_V3_DEFAULT,
    Spread: THREE_V3_DEFAULT,
    "Ball Screen Side": THREE_V3_DEFAULT,
    Mirror: THREE_V3_DEFAULT,
    "Pick and Roll": THREE_V3_DEFAULT,
    Misdirection: THREE_V3_DEFAULT,
    "Isolation Clear": THREE_V3_DEFAULT,
    "Push Pace": THREE_V3_DEFAULT,
    "Fly Wheel": THREE_V3_DEFAULT,
    "Quick Strike": THREE_V3_DEFAULT,
  },
};

export function getBasketballFormationLayout(gameFormat, formationName) {
  const formatLayouts = BASKETBALL_FORMATION_LAYOUTS[gameFormat] || {};
  return (
    formatLayouts[formationName] ||
    (gameFormat === "3v3" ? THREE_V3_DEFAULT : FIVE_V5_DEFAULT)
  );
}

export const BASKETBALL_FORMATION_CATEGORIES = [
  { id: "defensive", label: "Defensive", icon: "fa-solid fa-shield" },
  { id: "balanced", label: "Balanced", icon: "fa-solid fa-balance-scale" },
  { id: "attacking", label: "Attacking", icon: "fa-solid fa-fire" },
  { id: "uptempo", label: "Uptempo", icon: "fa-solid fa-bolt" },
];

export const BASKETBALL_GAME_FORMATS = [
  { value: "5v5", label: "5v5 full court" },
  { value: "3v3", label: "3v3 half court" },
];
